import { ToggleButton, ToggleButtonGroup } from '@mui/material';

export interface SegmentedControlOption<T extends string> {
  readonly label: string;
  readonly value: T;
}

export interface SegmentedControlProps<T extends string> {
  readonly ariaLabel: string;
  readonly onChange: (value: T) => void;
  readonly options: readonly SegmentedControlOption<T>[];
  readonly value: T;
}

export function SegmentedControl<T extends string>({
  ariaLabel,
  onChange,
  options,
  value,
}: SegmentedControlProps<T>) {
  return (
    <ToggleButtonGroup
      aria-label={ariaLabel}
      exclusive
      onChange={(_event, next: T | null) => {
        // A null value means the active button was clicked again; keep the current selection so the
        // control can never end up with nothing selected.
        if (next !== null) onChange(next);
      }}
      size="small"
      sx={{ bgcolor: 'surface.subtle', p: 0.5 }}
      value={value}
    >
      {options.map((option) => (
        <ToggleButton key={option.value} sx={{ border: 0, px: 1.5 }} value={option.value}>
          {option.label}
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  );
}
